export const consentPage = 'prodRecConsent';
